module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_course02-c0f350f294f97f8093aa274e7b4fc4cb.png";